

export const instancesPrice = {
    free: 0,
    starter: 29,
    shared: 59,
    profesional: 99,
    enterprise: 299,
    agent: 0,
}

export const serversPrice = {
    v1: 79
}
